import { RouteConfig } from 'vue-router'

const CommentRule = () => import('../views/comment/Rule.vue')

export const commentRuleRoute: RouteConfig = {
  path: '/comment-rule',
  name: 'comment_rule',
  component: CommentRule,
}

export default [commentRuleRoute]
